import { cronosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/cronos/default-constants';

export const CRODEX_CONTRACT_ADDRESS = '0xeC0A7a0C2439E8Cb67b992b12ecd020Ea943c7Be';

export const CRODEX_PROVIDER_CONFIGURATION = cronosProviderConfiguration;
